// extracted by mini-css-extract-plugin
export var socialProofContainer = "styles-module--socialProofContainer--3h3K1";
export var socialProofLogo = "styles-module--socialProofLogo--1b_Ay";